import { useEffect } from 'react';

const Loader = () => {
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styleTag);
  }, []);

  return (
    <div style={styles.overlay}>
      <div style={styles.spinner}></div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, bottom: 0, right: 0,
    background: 'rgba(0,0,0,0.3)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  spinner: {
    width: 50,
    height: 50,
    border: '6px solid #ccc',
    borderTop: '6px solid #007bff',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
};

export default Loader;
